import { render, staticRenderFns } from "./AutoRewardsSetupCard.vue?vue&type=template&id=ff85976a"
import script from "./AutoRewardsSetupCard.vue?vue&type=script&lang=js"
export * from "./AutoRewardsSetupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports